<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">

        <b-card class="w-100 h-100">

        <b-row>
      
          <b-col cols="6" md="6">
            <b-form-group label="ชื่อรายละเอียด (ไทย)" label-for="description">
              <b-form-input
                id="description"
                v-model="manageData.description"
                placeholder="กรุณากรอก รายละเอียด"
              />
            </b-form-group>
          </b-col>


          <b-col cols="6" md="6">
            <b-form-group label="ชื่อรายละเอียด (อังกฤษ)" label-for="descriptionEn">
              <b-form-input
                id="descriptionEn"
                v-model="manageData.descriptionEn"
                placeholder="กรุณากรอก รายละเอียด"
              />
            </b-form-group>
          </b-col>
        </b-row>

          <b-col cols="12"></b-col>

          <b-col cols="12" md="6" class="mb-5">
            <b-form-group label="สถานะการใช้งาน">
              <b-form-radio-group
                id="isActive"
                v-model="manageData.isActive"
                :options="activeOptions"                
                name="radio-is-active"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-between">
            <b-button variant="secondary" @click="onCancelBtnClicked">
              ยกเลิก
            </b-button>
            <b-button variant="primary" @click="onSubmitBtnClicked">
              บันทึกข้อมูล
            </b-button>
          </b-col>
        </b-card>
      
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as roleStore from "@/store/api/role/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      manageData: {
        description: "",
        descriptionEN: "",
        isActive: true,
        masterTypeId: 0,
      },

      role: {
        isActive: true,
      },
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
    };
  },
  created() {
      if(this.$route.query.masterTypeId == 8)
      this.redirectBackName="MasterPurchasePlace";
      else if(this.$route.query.masterTypeId == 9)
      this.redirectBackName="MasterPurchasePropagate";
      else if(this.$route.query.masterTypeId == 10)
      this.redirectBackName="MasterPurchaseMethod";
      else if(this.$route.query.masterTypeId == 12)
      this.redirectBackName="MasterNotifyPurpose";

    const _this = this;
    if (this.$route.query.masterId == null) //add
    {
      _this.manageData.masterTypeId = this.$route.query.masterTypeId?parseInt(this.$route.query.masterTypeId):0;
      _this.manageData.updateBy = userData.userId()
      _this.manageData.createBy = userData.userId()
    } else { //edit
      const masterId = this.$route.query.masterId;
      storeMaster.TmMasterGetByMasterId(masterId).then((response) => {
          _this.manageData = response.data.data;
          _this.manageData.updateBy = userData.userId()
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  },
  methods: {
    onSubmitBtnClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {

          storeMaster
            .TmMasterUpdate(_this.manageData)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                window.open(
                  _this.$router.resolve({
                    name: this.redirectBackName,
                  }).href,
                  "_self"
                );
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: this.redirectBackName }).href, "_self");
    },
  },
};
</script>

<style lang="scss"></style>
